import { render, staticRenderFns } from "./LenderStats.vue?vue&type=template&id=fc2f12fe&"
import script from "./LenderStats.vue?vue&type=script&lang=js&"
export * from "./LenderStats.vue?vue&type=script&lang=js&"
import style0 from "./LenderStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports